// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";

// Your Firebase configuration (Replace with actual Firebase credentials)
const firebaseConfig = {
    apiKey: "AIzaSyD19ag4jlslGH_YrmczkMFX_WrXn95dGvc",
    authDomain: "ethertrack-d9d02.firebaseapp.com",
    projectId: "ethertrack-d9d02",
    storageBucket: "ethertrack-d9d02.appspot.com",
    messagingSenderId: "312361710283",
    appId: "1:312361710283:web:de99711a69d589e21ce14e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

export { auth, googleProvider, facebookProvider };
